module.exports = __webpack_public_path__ + "img/메인좌측배너평생도메인.4ee10cb6.png";